import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss'],
  standalone: true,
})
export class StartComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
